'use strict'

import React, { PureComponent } from 'react'
import './ClickAndCollect.scss'

class ClickAndCollect extends PureComponent {
  render () {
    return (
      <div className='click-collect click-collect-wrap'>
        <p className='cc-text sc-store-service-clickandcollect'>
          <span className='cc-icon-text-wrap'>
            <span className='cc-icon-pointer' aria-hidden='true' />
            Click &amp; collect
          </span>
          <span className='cc-spacer' aria-hidden='true'> | </span>
          <span className='cc-message cc-message-sc'>Pay online collect in store</span>
          <span className='cc-message cc-message-sd'>Remember to pay online before you collect in store</span>
        </p>
      </div>
    )
  }
}

export default ClickAndCollect



// WEBPACK FOOTER //
// ./src/components/ClickAndCollect/ClickAndCollect.jsx